import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { loggedInUser } from '../helpers/utils';
import { User } from '../models/users.model';
import { loginApi, forgotPasswordApi, setNewPasswordApi } from '../../api/auth';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: any;

  constructor(private http: HttpClient) {}

  /**
   * Obtener usuario actual
   */
  public currentUser(): User | null {
    if (!this.user) {
      this.user = loggedInUser();
    }
    return this.user;
  }

  /**
   * Limpiar caché del usuario actual
   * Útil cuando se actualizan los datos del usuario en sessionStorage
   */
  public clearUserCache(): void {
    this.user = null;
  }

  /**
   * Iniciar sesión
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string): Observable<User> {
    return loginApi(this.http, email, password).pipe(map((user) => user));
  }

  /**
   * Petición de cambio de contraseña
   * @param email email of user
   */
  forgotPassword(email: string): Observable<any> {
    return forgotPasswordApi(this.http, email);
  }

  /**
   * Establecer nueva contraseña
   * @param token user token
   * @param newPassword new password
   * @param changeToken optional change token (user exists on other tenant) only send if not empty
   */
  setNewPassword(
    token: string,
    newPassword: string,
    changeToken?: string
  ): Observable<any> {
    return setNewPasswordApi(
      this.http,
      token,
      newPassword,
      changeToken ? changeToken : ''
    );
  }

  /**
   * Cerrar sesión
   */
  logout(): void {
    sessionStorage.removeItem('cayc-user');
    this.user = null;
  }

  getToken() {
    return this.currentUser()?.token;
  }
}
